module.exports = __webpack_public_path__ + "assets/img/kv-03634f89.jpg";